/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconArrow({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconArrow">  <path fill="currentColor" d="M213 141H70.4l50.1 50.9-16.5 16.8L25.6 129 104 49.3l16.5 16.8L70.4 117H213v24z" /></svg>
  );
}

IconArrow.propTypes = iconPropTypes;
IconArrow.defaultProps = iconDefaultProps;
